<script>
  import { makeId } from '../utils.js';
  import { createEventDispatcher } from 'svelte';
  import Fa from 'svelte-fa';
  import { faTimes } from '@fortawesome/free-solid-svg-icons';

  const dispatch = createEventDispatcher();

  export let label = "";
  export let placeholder = "";
  export let suffix = "";
  export let text = "";
  export let textAlign = "left";
  export let inputmode = "text";
  export let pattern = null;
  export let helpText = "";
  export let errorText = "";
  export let clearErrorOnEdit = false;
  export let clearButton = false;
  export let width = undefined;
  export let height = "32px";

  let focused = false;

  $: inputId = label + makeId(10);
  $: error = errorText.length > 0;

  const normalColor = "#666";
  const hoverColor = "#333";
  const pressColor = "#111";
  let color = normalColor;

  function gotFocus() {
    focused = true;
    dispatch('gotFocus');
  }
  
  function lostFocus() {
    focused = false;
    dispatch('lostFocus');
  }

  function onKeydown() {
    if (clearErrorOnEdit) errorText = "";
    dispatch('keydown');
  }
</script>

<div class="container" style="width: {width}">
  <label for={inputId} class:focused={focused && !error} class:error>{label}</label>
  <div class="inputContainer">
    <input id={inputId} class:error type="text" placeholder={focused ? "" : placeholder} bind:value={text} {inputmode} {pattern} style="text-align: {textAlign}; height: {height};"
        on:focus={() => gotFocus()} on:blur={() => lostFocus()} on:change on:keydown={onKeydown}>
    <div class="extra">
      {#if suffix}
          <span class="suffix">{suffix}</span>
      {/if}
      {#if clearButton && text}
        <button on:click={() => text = ""} on:mouseenter={() => color = hoverColor} on:mouseleave={() => color = normalColor}
                on:mousedown={() => color = pressColor} on:mouseup={() => color = hoverColor}>
          <Fa icon={faTimes} {color} />
        </button>
      {/if}
    </div>
  </div>
  <span class="helpText" class:error>{errorText ? errorText : helpText}</span>
</div>

<style>
  .container {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    pointer-events: auto;
  }
  
  .inputContainer {
    display: grid;
  }

  input {
    grid-row-start: 1;
    grid-column: 1 / span 2;
    background-color: white;
    border-color: #ccc;
    border-radius: var(--border-radius);
    outline: none;
    margin: 0;
  }

  input:hover {
    border-color: gray;
  }

  input:focus {
    border-color: var(--primary-color);
  }

  input.error {
    border-color: var(--error-color);
  }

  label {
    text-align: left;
    padding: 0px 4px;
    color: #333;
    font-size: var(--label-font-size)px;
  }

  label.error, span.error {
    color: var(--error-color);
  }

  .error {
    animation: shake 0.1s;
    animation-iteration-count: 3;
  }

  .extra {
    grid-row-start: 1;
    grid-column-start: 2;
    justify-self: center;
    align-self: center;
    z-index: 1;
    padding: 2px 6px;
  }

  .suffix {
    color: #aaa;
    font-size: 14px;
    pointer-events: none;
  }

  button {
    background-color: transparent;
    border: none;
    margin: auto;
    padding: 3px;
  }

  button:focus {
    background-color: transparent;
  }

  .helpText {
    display: block;
    position: relative;
    text-align: left;
    top: -2px;
    left: 4px;
    font-size: 13px;
    font-style: italic;
    color: #777;
  }

  .focused {
    color: var(--primary-color);
  }

  @keyframes shake {
    0% { transform: translate(1px, 0px); }
    33% { transform: translate(0px, 0px); }
    66% { transform: translate(-1px, 0px); }
    100% { transform: translate(0px, 0px); }
  }
</style>